import { render, staticRenderFns } from "./AdminSettingsSharingForm.vue?vue&type=template&id=42201996&scoped=true"
import script from "./AdminSettingsSharingForm.vue?vue&type=script&lang=ts"
export * from "./AdminSettingsSharingForm.vue?vue&type=script&lang=ts"
import style0 from "./AdminSettingsSharingForm.vue?vue&type=style&index=0&id=42201996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42201996",
  null
  
)

export default component.exports